export default __webpack_public_path__ + "static/media/woman-sitted.64a4a5e2.svg";